/**
 * Точка входа UI бэклога.
 *
 * Flow: монтирует App в #root под барьером падений. Роутинга нет — приложение
 * это одна доска с модальной панелью карточки; вводить маршрутизатор ради
 * одного экрана значит добавить зависимость, которой нечего маршрутизировать.
 *
 * Барьер стоит ВЫШЕ App, а не внутри: падение случалось в инициализаторе
 * состояния самого App, и барьер внутри него не успел бы смонтироваться.
 */
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import ErrorBoundary from './ErrorBoundary.jsx'
import './styles.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
)
